class CollectionFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.filtersApplied = false;
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.productGridId = 'CollectionProductGrid';
    this.filterFormsId = 'CollectionFiltersForm';
    this.sections = this.getSections();
    this.searchTemplate = document.querySelector('#main-body.search-template');
    this.collectionTemplate = document.querySelector('#main-body.collection-template');

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    document.querySelector('[data-drawer-open-btn]').addEventListener('click', this.handleDrawerOpen.bind(this));
    this.addDrawerListeners.bind(this);
    window.addEventListener('resize', this.addDrawerListeners.bind(this));
    window.addEventListener('resize', this.setFilterDrawerPosition.bind(this));

    window.addEventListener('popstate', this.onHistoryChange.bind(this));

    this.bindActiveFacetButtonEvents();

    this.onDropDownBlur();
  }

  onDropDownBlur() {
    const getDropDowns = document.querySelectorAll('details');

    for (let item of getDropDowns) {
      document.addEventListener('click', function (event) {
        var isClickInside = item.contains(event.target);

        if (!isClickInside) {
          //the click was outside the specifiedElement, close the dropdown
          item.removeAttribute('open');
        }
      });
    }
  }

  isHidden(el) {
    return (el.offsetParent === null)
  }

  addDrawerListeners() {
    const filterDrawer = document.querySelector('collection-filtering-form');
    filterDrawer.removeAttribute('role');
    filterDrawer.removeAttribute('aria-modal');

    if (window.innerWidth < 991) {
      filterDrawer.setAttribute('role', 'dialog');
      filterDrawer.setAttribute('aria-modal', 'true');
      this.setFilterDrawerPosition();
    }

    const drawerOpenBtn = document.querySelector('[data-drawer-open-btn]');

    if (this.isHidden(drawerOpenBtn)) return;
    drawerOpenBtn.addEventListener('click', this.handleDrawerOpen);
  }

  setFilterDrawerPosition() {
    const headerHeight = document.querySelector('[data-header]').offsetHeight;
    const filterDrawer = document.querySelector('#CollectionFiltersForm');
    // filterDrawer.style.top = `${headerHeight}px`;
    filterDrawer.style.top = `0px`;
  }

  handleDrawerOpen(e) {
    e.target.setAttribute('tabIndex', '-1');
    const filterWrapper = document.querySelector('collection-filtering-form');
    const drawerCloseBtn = this.querySelector('[data-drawer-close-btn]')

    // filterWrapper.style.visibility = 'visible';
    this.setFilterDrawerPosition();
    filterWrapper.classList.add('is-open');
    document.body.classList.add('scroll-locked');
    this.trapFocus('main-collection-filters', true);
    drawerCloseBtn.addEventListener('click', this.handleDrawerClose.bind(this));

    document.addEventListener('click', (e) => this.handleOffDrawerClick(e), true);
  }

  handleOffDrawerClick(e) {
    // @todo: figure out why this method keeps getting called
    const filterDrawer = document.querySelector('#CollectionFiltersForm');
    const isDrawerClick = filterDrawer.contains(e.target);

    if (!isDrawerClick) this.handleDrawerClose.bind(this);
  }

  handleDrawerClose() {
    const filterDrawer = document.querySelector('collection-filtering-form');
    const filterBtn = document.querySelector('[data-drawer-open-btn]');

    document.body.classList.remove('scroll-locked');

    filterDrawer.classList.remove('is-open');
    // filterDrawer.style.visibility = 'hidden';
    filterBtn.setAttribute('tabIndex', '0');
    filterBtn.focus();
    document.removeEventListener('click', this.handleOffDrawerClick, true);
  }

  trapFocus(slideout_id, is_initial_open) {
    const idString = `#${slideout_id}`;
    const menu = document.getElementById(slideout_id);
    const togglers = document.querySelectorAll('.facets__disclosure, .collection-filters__sort');
    const inputs = document.querySelectorAll(`${idString} input:not([type=hidden]), ${idString} button:not([tabindex="-1"]), ${idString} a:not([tabindex="-1"]), ${idString} textarea`);
    // The first input will always stay the same so we'll declare it here
    const firstInput = inputs[0];
    let lastInput;


    menu.addEventListener('keydown', function (e) {
      const getLastToggler = (togglers[togglers.length - 1]);
      const lastGroupCollapsed = !getLastToggler.hasAttribute('open');

      // If the last tag list is collapsed, the toggle button becomes the 'last input'
      // else the last input is equal to the last input in the array
      lastInput = lastGroupCollapsed ? getLastToggler : (inputs[inputs.length - 1]);

      // Redirect last tab to first input
      if (e.code === 'Tab' && !e.shiftKey && document.activeElement == lastInput) {
        e.preventDefault();
        firstInput.focus();
      }

      // Redirect first shift+tab to last input
      if (e.code === 'Tab' && e.shiftKey && document.activeElement == firstInput) {
        e.preventDefault();
        lastInput.focus();
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.collectionTemplate) {
      const formData = new FormData(event.target.closest('form'));

      let filtersApplied = false;

      for (const entry of formData.entries()) {
        const [param, value] = entry;
        if (param.indexOf('filter.') == 0 && value) {
          filtersApplied = true;
          break;
        }
      }

      if (filtersApplied) {
        formData.append('filter.v.availability', 1);

      }

      this.filtersApplied = filtersApplied;

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    } else if (this.searchTemplate) {
      // Store the initial URL so that we can get the search query from it to add to the formData object
      const searchParamsInitial = new URLSearchParams(window.location.search);

      // Get the selected result types, we will need to use them later on
      const activeTypes = document.querySelector('#page-type-input').value;
      const types = Array.from(activeTypes.split(','));
      const defaultTypes = document.querySelector('input#sort-types');

      if (activeTypes == "") {
        const getInput = document.querySelector('#page-type-input');
        getInput.value = defaultTypes.value;
      }

      // Add the initial search query to the formData object otherwise the query will be lost and we will get an error
      const formData = new FormData(event.target.closest('form'));
      formData.append('q', searchParamsInitial.get('q'));

      // If the result type is not of type product, we want to disable the filter inputs and remove product type queries from the URL
      if (types.includes('article') && !types.includes('product') || types.includes('page') && !types.includes('product')) {
        const getInputs = document.querySelectorAll(`#${this.filterFormsId} input:not(#page-type-input)`);
        const getLabels = document.querySelectorAll(`#${this.filterFormsId} label:not(.collection-filters__label)`);

        // Disable the inputs if the result type is article or page
        for (let item of getInputs) {
          item.setAttribute('disabled', 'disabled');
        }

        for (let inputLabel of getLabels) {
          inputLabel.classList.add('facet-checkbox--disabled');
        }

        // If our result is an article or page type, remove all product related filters from the URL
        if (searchParamsInitial.has('filter.p.product_type')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.product_type');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.p.vendor')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.p.vendor');
          this.renderPage(newFormData, event);
        }

        if (searchParamsInitial.has('filter.v.availability')) {
          let newFormData = new URLSearchParams(window.location.search).toString();
          formData.delete('filter.v.availability');
          this.renderPage(newFormData, event);
        }
      }

      const searchParams = new URLSearchParams(formData).toString();
      this.renderPage(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    this.toggleActiveFacets();
    let searchParams = new URL(event.target.href).searchParams;
    let filtersApplied = false;

    if (searchParams.has('filter.v.availability')) {
      searchParams.delete('filter.v.availability');
    }

    for (const param of searchParams.entries()) {
      const [name, value] = param;
      if (name.indexOf('filter.') == 0 && value) {
        filtersApplied = true;
        break;
      }
    }

    if (filtersApplied) {
      searchParams.append('filter.v.availability', '1');
    }

    this.filtersApplied = filtersApplied;

    this.renderPage(searchParams.toString());
  }

  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, null, false);
  }

  toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  renderPage(searchParams, event, updateURLHash = true) {
    document.querySelector(`#${this.productGridId}>div`).classList.add('loading');

    this.sections.forEach((section) => {
      if (this.collectionTemplate) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      } else if (this.searchTemplate) {
        const url = `${window.location.pathname}?${searchParams}`;
        const filterDataUrl = element => element.url === url;

        this.filterData.some(filterDataUrl) ?
          this.renderSectionFromCache(filterDataUrl, section, event) :
          this.renderSectionFromFetch(url, section, event);
      }
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, section, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];

        switch (section.id) {
          case this.productGridId:
            this.renderProductGrid(html);
            break;
          case this.filterFormsId:
            this.renderFilters(html, event);
            break;
          default:
            return;
        }
      }).then(() => {
        const allProductItems = document.querySelectorAll('.product-item');

        for (let i = 0; i < allProductItems.length; i++) {
          const item = allProductItems[i];

          window.productCardVariantSelect = function () {
            //variants
            let itemVariants = document.querySelectorAll('.product-item__variants-variant');

            for (let j = 0; j < itemVariants.length; j++) {
              const variant = itemVariants[j];

              variant.addEventListener('click', function (e) {
                let selectedVariant = e.currentTarget;

                //console.log('SELECTED', selectedVariant);

                removeActiveClass();

                selectedVariant.classList.add('active');

                selectedVariant.parentNode.parentNode.querySelector('.quick-atc-btn').classList.add('show');
              })
            }

            function removeActiveClass() {
              itemVariants.forEach(item => {
                item.classList.remove('active');
              });
            }
          }

          window.productCardVariantSelect();

          window.productCardQuickAddToCart = function () {
            //show product atc popup
            let atcShowButtons = document.querySelectorAll('.quick-atc-show');

            for (let button of atcShowButtons) {
              //for (let k = 0; k < atcShowButtons.length; k++) {
              //const button = atcShowButtons[k];

              button.addEventListener('click', function (e) {
                let selectedAtcButton = e.target;
                selectedAtcButton.classList.add('hide')
                //console.log('EVENT CLICKED', selectedAtcButton.parentNode.querySelector('.product-item-quick-add'))
                let quickAddContainer = selectedAtcButton.parentNode.querySelector('.product-item-quick-add');
                quickAddContainer.classList.add('show');

              })
            }

            //hide product atc popup
            let atcHideButtons = item.querySelectorAll('.quick-atc-close');

            for (let y = 0; y < atcHideButtons.length; y++) {
              const button = atcHideButtons[y];

              button.addEventListener('click', function (e) {
                let selectedCloseBtn = e.target;
                selectedCloseBtn.parentNode.parentNode.classList.remove('show');
                selectedCloseBtn.parentNode.parentNode.parentNode.querySelector('.quick-atc-show').classList.remove('hide');
              })
            }
          }

          window.productCardQuickAddToCart();

        }
      })
  }

  renderSectionFromCache(filterDataUrl, section, event) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html, event);
    this.renderProductGrid(html);
  }

  renderProductGrid(html) {
    const innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById(this.productGridId).innerHTML;

    document.getElementById(this.productGridId).innerHTML = innerHTML;
  }

  renderFilters(html, event) {

    const htmlToRender = this.filtersApplied ? html : window.cakeInitialFilterSectionMarkup;

    const parsedHTML = new DOMParser().parseFromString(htmlToRender, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll(`#${this.filterFormsId} .js-filter`);

    const matchesIndex = (element) => element.dataset.index === event?.target.closest('.js-filter')?.dataset.index
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    this.renderActiveFacets(parsedHTML);

    if (countsToRender) this.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    this.bindActiveFacetButtonEvents();
    this.toggleActiveFacets(false);
  }

  renderMobileElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('CollectionFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  renderCounts(source, target) {
    const countElementSelectors = ['.count-bubble', '.facets__selected'];
    countElementSelectors.forEach((selector) => {
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML = source.querySelector(selector).outerHTML;
      }
    });
  }

  bindActiveFacetButtonEvents() {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick, { once: true });
    });
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        id: this.productGridId,
        section: document.getElementById(this.productGridId).dataset.sectionId
      },
      {
        id: this.filterFormsId,
        section: document.getElementById('main-collection-filters').dataset.id
      }
    ]
  }
}

customElements.define('collection-filtering-form', CollectionFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', '0');
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range-selector', PriceRange);

class PageType extends HTMLElement {
  constructor() {
    super()
    this.selector = document.querySelector('[data-page-type-selector]');
    this.selector.addEventListener('change', this.setValue);
  }

  setValue(e) {
    const selectedTypes = e.currentTarget.querySelectorAll('input:checked');
    const types = Array.from(selectedTypes).map(option => option.value).join(',');

    const typeInput = document.querySelector('#page-type-input');
    typeInput.value = types;

    const event = new Event('input');
    typeInput.closest('form').dispatchEvent(event);
  }
}

customElements.define('page-type-selector', PageType);
